import { render, staticRenderFns } from "./PromptingLab.vue?vue&type=template&id=52a3b582&scoped=true&"
import script from "./PromptingLab.vue?vue&type=script&lang=js&"
export * from "./PromptingLab.vue?vue&type=script&lang=js&"
import style0 from "./PromptingLab.vue?vue&type=style&index=0&id=52a3b582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3b582",
  null
  
)

export default component.exports